// extracted by mini-css-extract-plugin
export var social = "social-module--social--hllcC";
export var socialAccent = "social-module--social--accent--ofAnI";
export var socialEmail = "social-module--social--email--GlbQP";
export var socialGithub = "social-module--social--github---kiwb";
export var socialLinkedin = "social-module--social--linkedin--64OXD";